import { Alert, Button, Input, Typography } from '@arco-design/web-react';
import { IconLarkColor, IconLock, IconUser } from '@arco-design/web-react/icon';

const { Text } = Typography;

export type LoginContent = {
  platformName: string;
  welcomeText: string;
  usernamePlaceholder: string;
  passwordPlaceholder: string;
  businessHighlights: string[];
};

type LoginViewProps = {
  content: LoginContent;
  backgroundSrc: string;
  logoSrc: string;
  identifier: string;
  password: string;
  loading: boolean;
  feishuLoading: boolean;
  feishuAvailable: boolean;
  error?: string;
  autoLoginFailed?: boolean;
  onRetryFeishu?: () => void;
  onIdentifierChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onLogin: () => void;
  onFeishuLogin: () => void;
};

export function LoginView(props: LoginViewProps) {
  return (
    <main className="login-page">
      <img
        className="login-page__background"
        src={props.backgroundSrc}
        alt=""
        aria-hidden="true"
        draggable={false}
      />
      <section className="login-page__brand">
        <img
          className="login-page__company-logo"
          src={props.logoSrc}
          alt="巨鲲公司 LOGO"
          draggable={false}
        />
        <div className="login-page__brand-copy">
          <h1>{props.content.platformName}</h1>
          <p>
            {props.content.businessHighlights.map(highlight => (
              <span key={highlight}>{highlight}</span>
            ))}
          </p>
        </div>
      </section>

      <section className="login-card" aria-label="登录巨鲲云平台">
        <div className="login-card__head">
          <div>
            <Text type="secondary">{props.content.platformName}</Text>
            <h2>{props.content.welcomeText}</h2>
          </div>
          <span className="login-card__language">中文（简体）</span>
        </div>
        {props.feishuAvailable ? <div className="login-card__feishu">
          <Button className="login-card__feishu-button" long loading={props.feishuLoading}
            disabled={props.loading} onClick={props.onFeishuLogin}>
            <span className="login-card__feishu-icon"><IconLarkColor /></span>
            <span>飞书登录</span>
          </Button>
          <span className="login-card__feishu-divider">或使用账号密码登录</span>
        </div> : null}
        {props.error ? <Alert className="login-card__error" type="error" content={props.error} /> : null}
        {props.autoLoginFailed ? <div className="login-card__error">
          <Alert type="warning" content="自动登录失败" />
          <Button type="primary" onClick={props.onRetryFeishu}>重试自动登录</Button>
        </div> : null}
        <form
          className="login-card__form uikit-main"
          onSubmit={event => {
            event.preventDefault();
            props.onLogin();
          }}
        >
          <Input
            height={40}
            prefix={<IconUser />}
            placeholder={props.content.usernamePlaceholder}
            value={props.identifier}
            onChange={props.onIdentifierChange}
          />
          <Input.Password
            height={40}
            prefix={<IconLock />}
            placeholder={props.content.passwordPlaceholder}
            value={props.password}
            onChange={props.onPasswordChange}
          />
          <Button type="primary" htmlType="submit" long loading={props.loading}
            disabled={props.feishuLoading}>
            登录
          </Button>
        </form>
      </section>
    </main>
  );
}
